export enum HighCommissionBoosting {
  NAME = 'plp_hc_boosting',
  OFF = 'off',
  ON = 'on',
}
